module.exports = __webpack_public_path__ + "main_hall-8eda24d62eef0a4a8a23ed1a32f5515d.png";